import { t } from '@unistocks/shared/localization/index.ts';
import { Stack } from 'expo-router';

export default function SavingsGoalsLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: 'transparent' }
      }}
    >
      <Stack.Screen name="index" options={{ title: t('::Menu:SavingsGoals') }} />
      <Stack.Screen name="[id]/index" />
      <Stack.Screen name="create" options={{ title: t('::Menu:SavingsGoals:Create') }} />
    </Stack>
  );
}
